"use client";
import React from "react";
import Image from "next/image";

interface EventCardProps {
  image: string;
  value: string | undefined;
  details?: string;
}

const EventsCard: React.FC<EventCardProps> = ({ image, value, details }) => {
  return (
    <fieldset className="w-full border border-slate-200 p-4 rounded-lg flex items-start justify-start text-left">
      <legend className="flex items-start justify-start bg-transparent">
        <Image
          src={`/Images/${image}.png`}
          alt="Image"
          width={300}
          height={300}
          className="w-24 h-24 p-2 border border-slate-200 rounded-full shadow shadow-slate-200"
        />
      </legend>
      <div className="flex flex-col gap-1 justify-start items-start w-full">
        <div className="w-full flex justify-between items-center -mt-4">
          <h2 className="text-md font-semibold text-orange-600 capitalize">
            {image}
          </h2>
          <h1 className="text-xl lg:text-3xl font-black text-slate-400">
            ${value}
          </h1>
        </div>
        <p className="text-sm font-semibold text-slate-500 mt-2 text-left">
          {details}
        </p>
      </div>
    </fieldset>
  );
};

export default EventsCard;
